<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
      <c-table
        ref="gridworker"
        title="설문 대상자"
        :columns="gridworker.columns"
        :gridHeight="gridworker.height"
        :data="surveies"
        :columnSetting="false"
        :usePaging="false"
        :isExcelDown="false"
        :isFullScreen="false"
        @rowClick="rowClick"
      >
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
      <component
        v-if="param.heaMuscleWorkerSurveyId"
        :is="component"
        :popupParam.sync="param"
        :contentHeight="contentHeight"
      />
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'symptomSurveyStatusDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        heaInvestigationPlanId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      component: () => import(`${'./symptomSurveyDetail.vue'}`),
      param: {
        heaMuscleWorkerSurveyId: '',
        readOnly: true,
      },
      gridworker: {
        columns: [
          {
            name: 'deptName',
            field: 'deptName',
            label: 'LBLDEPT',
            align: 'center',
            style: 'width:40%',
            sortable: false,
          },
          {
            name: 'userName',
            field: 'userName',
            label: 'LBLNAME',
            align: 'center',
            sortable: false,
          },
        ],
        height: ''
      },
      surveies: [],
      editable: true,
      listUrl: '',
    };
  },
  watch: {
    contentHeight() {
      let height = this.contentHeight - 30
      if (!height || height < 500) {
        height = 500;
      }
      this.gridworker.height = String(height) + 'px';
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.muscleSystem.muscleSurvey.list.url
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      this.$http.url = this.listUrl
      this.$http.type = 'GET';
      this.$http.param = {
        heaInvestigationPlanId: this.popupParam.heaInvestigationPlanId
      };
      this.$http.request((_result) => {
        this.surveies = _result.data
        this.$set(this.param, 'heaMuscleWorkerSurveyId', (this.surveies && this.surveies.length > 0 ? this.surveies[0].heaMuscleWorkerSurveyId : ''))
      },);
    },
    rowClick(row) {
      this.$set(this.param, 'heaMuscleWorkerSurveyId', row.heaMuscleWorkerSurveyId)
    }
  }
};
</script>
